/**
 * CMSD Version 1
 *
 * @group CMSD
 *
 * @beta
 */
export const CMSD_V1 = 1;
//# sourceMappingURL=CMSD_V1.js.map